import React from "react";
import { Brain, HeartHandshake, Users, Sparkles } from "lucide-react";
import Reveal from "../components/Reveal";
import { useSite } from "../context/SiteContext";

const ICONS = [Sparkles, Brain, HeartHandshake, Users];

export const Pillar = ({ standalone = false }) => {
    const { content } = useSite();
    const p = content.pillar || {};
    const title = (p.title || "").split("\n");

    return (
        <section
            id="pillar"
            data-testid="pillar-section"
            className={`relative bg-[#0A1F3D] text-white overflow-hidden ${
                standalone ? "pt-36 pb-28" : "py-24 lg:py-32"
            }`}
        >
            {/* decorative */}
            <div className="absolute -top-32 -right-32 w-[500px] h-[500px] rounded-full bg-[#14545E]/40 blur-3xl pointer-events-none" />
            <div className="absolute -bottom-32 -left-32 w-[400px] h-[400px] rounded-full bg-white/[0.04] blur-3xl pointer-events-none" />

            <div className="max-w-7xl mx-auto px-5 lg:px-10 relative">
                <div className="grid lg:grid-cols-12 gap-10 mb-16">
                    <Reveal className="lg:col-span-7">
                        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 text-white/90 text-[11px] tracking-[0.2em] uppercase mb-6">
                            {p.eyebrow}
                        </div>
                        <h2 className="font-serif-display text-4xl sm:text-5xl lg:text-7xl leading-[1.02]">
                            {title.map((line, i) => (
                                <div key={i}>
                                    {i === title.length - 1 ? (
                                        <span className="text-[#7FB8C6]">{line}</span>
                                    ) : (
                                        line
                                    )}
                                </div>
                            ))}
                        </h2>
                    </Reveal>
                    <Reveal delay={0.15} className="lg:col-span-5 flex items-end">
                        <p className="text-white/75 text-base lg:text-lg leading-relaxed">
                            {p.body}
                        </p>
                    </Reveal>
                </div>

                <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-4">
                    {(p.steps || []).map((s, i) => {
                        const Icon = ICONS[i % ICONS.length];
                        return (
                            <Reveal key={s.id || i} delay={i * 0.08}>
                                <div
                                    data-testid={`pillar-step-${i}`}
                                    className="group relative bg-white/[0.04] hover:bg-white/[0.08] border border-white/10 rounded-2xl p-7 h-full transition-colors"
                                >
                                    <div className="flex items-center justify-between mb-6">
                                        <div className="h-12 w-12 rounded-xl bg-[#14545E] flex items-center justify-center">
                                            <Icon size={20} className="text-white" />
                                        </div>
                                        <span className="font-serif-display text-3xl text-white/40">
                                            {s.step}
                                        </span>
                                    </div>
                                    <h3 className="font-serif-display text-xl mb-3 leading-tight">
                                        {s.title}
                                    </h3>
                                    <p className="text-sm text-white/65 leading-relaxed">
                                        {s.description}
                                    </p>
                                </div>
                            </Reveal>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default Pillar;
